const TYPES = {
  SignIn: "@Auth/SignIn",
  SignOut: "@Auth/SignOut",
  Update: "@Auth/Update",
};

const INITIAL_STATE = {
  logged: false,
  token: null,
  user: {},
};

export default function reducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case TYPES.SignIn:
      return {
        ...payload,
        logged: true,
      };

    case TYPES.SignOut:
      return INITIAL_STATE;

    case TYPES.Update:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
}

export function SignIn(payload) {
  return {
    type: TYPES.SignIn,
    payload,
  };
}

export function SignOut() {
  return {
    type: TYPES.SignOut,
  };
}

export function UpdateUser(user) {
  return {
    type: TYPES.Update,
    payload: {
      user,
    },
  };
}

export function UpdateToken(token) {
  return {
    type: TYPES.Update,
    payload: {
      token,
    },
  };
}
